// we do not check typing on this file as
// it uses some oldschool coding and would
// require some refactoring to be compliant
// @ts-nocheck

import "isomorphic-fetch";
import Transform from "minilog/lib/common/transform";

function FetchBackend(config) {
  this.cache = [];
  this.timer = null;
  this.uri = config.url || "";
  this.cid = new Date().valueOf().toString(36);
  this.interval = config.interval || 10000;
}

Transform.mixin(FetchBackend);

FetchBackend.prototype.write = function (name, level, args) {
  if (!this.timer) {
    this.init();
  }

  let data = args[0];

  if (level === "error") {
    data = {
      error: args[0],
      message: args[0].message,
      trace: args[0].stack,
    };
  }

  this.cache.push({
    context: name,
    level: level,
    data: data,
  });
};

FetchBackend.prototype.init = function () {
  this.timer = setTimeout(
    function () {
      if (this.cache.length === 0) {
        return this.init();
      }

      const url = this.uri + "?client_id=" + this.cid;
      fetch(url, {
        method: "post",
        body: JSON.stringify({ logs: this.cache }),
        headers: {
          "Content-Type": "application/json",
          credentials: "same-origin",
        },
      }).then(
        function (response) {
          this.init();
        }.bind(this)
      );

      this.cache = [];
    }.bind(this),
    this.interval
  );
};

FetchBackend.prototype.end = function () {};

export default FetchBackend;
